import React, { Component } from "react";

import PropTypes from "prop-types";

import { compose } from 'redux'

import { connect } from 'react-redux'

import {
  firestoreConnect,
  populate,
  isLoaded,
} from 'react-redux-firebase'

import { get, difference, } from "lodash";

import { withRouter, } from "react-router-dom";

import {
  Box,
  Grid,
  Paper,
  Hidden,
} from "@material-ui/core";

import { withStyles, } from "@material-ui/core/styles";

import Image from "material-ui-image";

import { auth, firestoreConstants, } from "../../firebase";

import Loader from "../Loader";

import CompletedSeason from "./CompletedSeason";

import InProgressSeason from "./InProgressSeason";

import routes, {
  SEASONS,
} from "../../data/routes";

import authentication from "../../services/authentication";

import {
  myUserEntry,
  rankings,
  seasonPredictions,
} from "../../data/season-constants";

import userEntries from "../../services/user-entries";

const imageHeight = "540px";
const mobileImageHeight = "240px";

const styles = () => ({
  grid: {
    margin: 0,
    width: "100%",
  },
});

class HomePage extends Component {
  signInWithEmailLink = () => {
    const { user } = this.props;

    if (user) {
      return;
    }

    const emailLink = window.location.href;

    if (!emailLink) {
      return;
    }

    if (auth.isSignInWithEmailLink(emailLink)) {
      let emailAddress = localStorage.getItem("emailAddress");

      if (!emailAddress) {
        this.props.history.push("/");

        return;
      }

      authentication
        .signInWithEmailLink(emailAddress, emailLink)
        .then((value) => {
          const user = value.user;
          const displayName = user.displayName;
          const emailAddress = user.email;

          this.props.openSnackbar(
            `Signed in as ${displayName || emailAddress}`
          );
        })
        .catch((reason) => {
          const code = reason.code;
          const message = reason.message;

          switch (code) {
            case "auth/expired-action-code":
            case "auth/invalid-email":
            case "auth/user-disabled":
              this.props.openSnackbar(message);
              break;

            default:
              this.props.openSnackbar(message);
              return;
          }
        })
        .finally(() => {
          this.props.history.push("/");
        });
    }
  };

  isRankingComplete = () => {
    const {
      myUserEntryAll,
      seasons,
    } = this.props;

    const params = get(this.props, "match.params");
    const {
      seasonId,
    } = params;

    const myUserEntry = myUserEntryAll === undefined || myUserEntryAll.length == 0 ? null : myUserEntryAll[0];
    const season = seasons === undefined ? null : seasons[seasonId];

    return userEntries.isStepComplete(rankings, myUserEntry, season);
  };

  isSeasonPredictionsComplete = () => {
    const {
      myUserEntryAll,
      seasons,
    } = this.props;

    const params = get(this.props, "match.params");
    const {
      seasonId,
    } = params;

    const myUserEntry = myUserEntryAll === undefined || myUserEntryAll.length == 0 ? null : myUserEntryAll[0];
    const season = seasons === undefined ? null : seasons[seasonId];

    return userEntries.isStepComplete(seasonPredictions, myUserEntry, season);
  };

  isWeeklyPredictionsComplete = () => {
    const {
      myUserEntryAll,
      seasons,
    } = this.props;

    const params = get(this.props, "match.params");
    const {
      seasonId,
    } = params;

    const myUserEntry = myUserEntryAll === undefined || myUserEntryAll.length == 0 ? null : myUserEntryAll[0];
    const season = seasons === undefined ? null : seasons[seasonId];

    if (!myUserEntry) {
      return false;
    }

    const {
      weeklyPredictions,
    } = myUserEntry;

    const {
      currentWeeklyPredictionsWeek,
      weeklyPredictionsQuestions = undefined,
    } = season;

    if (!weeklyPredictionsQuestions) {
      return true;
    }

    const questionsForWeek = weeklyPredictionsQuestions.byWeek[currentWeeklyPredictionsWeek];
    const questionIds = questionsForWeek.allIds;

    const weeklyPredictionsAnswers = get(weeklyPredictions, currentWeeklyPredictionsWeek);
    if (!weeklyPredictionsAnswers) {
      return false;
    }

    const answerIds = Object.keys(weeklyPredictionsAnswers).map(key => parseInt(key)).sort();
    return difference(questionIds, answerIds).length === 0;
  };

  isUserSetup = () => {
    const {
      user,
    } = this.props;

    return user && (user.firstName || user.lastName);
  };

  isLoaded = () => {
    const {
      seasons,
      myUserEntryAll,
      myUserEntryById,
    } = this.props;

    if (this.props.user) {
      return isLoaded(
        seasons,
        myUserEntryAll,
        myUserEntryById,
      );
    } else {
      return isLoaded(
        seasons,
      );
    }
  }

  render() {
    const {
      classes,
      user,
      myUserEntryAll,
      seasons,
    } = this.props;

    // Functions
    const {
      onSignUpClick,
      onSignInClick,
      onSettingsClick,
    } = this.props;

    const params = get(this.props, "match.params");
    const {
      seasonId,
    } = params;

    if (!this.isLoaded()) {
      return <Loader />;
    }

    const rankingsComplete = userEntries.isRankingComplete(myUserEntryAll, seasons);
    const seasonPredictionsComplete = this.isSeasonPredictionsComplete();
    const isUserComplete = this.isUserSetup();
    const season = seasons[seasonId];

    const {
      imageUrl,
      isSeasonOver,
    } = season;

    const weeklyPredictionsComplete = season.isWeeklyPredictionsLocked ? true : this.isWeeklyPredictionsComplete();
    const baseUrl = routes[SEASONS].pathWithoutParam + seasonId;

    const content = isSeasonOver ? (
      <CompletedSeason
        season={season}
        baseUrl={baseUrl}
        user={user}
      />
    ) : (
      <InProgressSeason
        season={season}
        baseUrl={baseUrl}
        user={user}
        rankingsComplete={rankingsComplete}
        seasonPredictionsComplete={seasonPredictionsComplete}
        weeklyPredictionsComplete={weeklyPredictionsComplete}
        isUserComplete={isUserComplete}
        onSignUpClick={onSignUpClick}
        onSignInClick={onSignInClick}
        onSettingsClick={onSettingsClick}
      />
    );

    return (
      <Box>
        <Hidden mdUp>
          <Box alignItems="center" justify="center" className={classes.grid}>
            <Box style={{ height: mobileImageHeight }}>
              <Image
                src={`/images/${imageUrl}`}
                cover
                disableTransition
                imageStyle={{ height: mobileImageHeight }}
                iconContainerStyle={{ height: mobileImageHeight }}
                style={{ paddingTop: 0 }}
              />
            </Box>
            <Box>
              <Paper>
                <Grid container spacing={7} className={classes.grid}>
                  <Grid item xs={12}>
                    {content}
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          </Box>
        </Hidden>
        <Hidden smDown>
          <Grid
            container
            alignItems="center"
            justify="center"
            className={classes.grid}
          >
            <Grid item xs={10}>
              <Box style={{ height: imageHeight }}>
                <Image
                  src={`/images/${imageUrl}`}
                  cover
                  disableTransition
                  imageStyle={{ height: imageHeight }}
                  iconContainerStyle={{ height: imageHeight }}
                  style={{ paddingTop: 0 }}
                />
              </Box>
            </Grid>
            <Grid item xs={10}>
              <Paper>
                <Box p={3}>
                  <Grid container spacing={7} className={classes.grid}>
                    <Grid item xs={12}>
                      {content}
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Hidden>
      </Box>
    );
  }

  componentDidMount() {
    this.signInWithEmailLink();
  }
}

HomePage.propTypes = {
  user: PropTypes.object,
};

function mapStateToProps(state, props) {
  const params = get(props, "match.params");
  const {
    seasonId,
  } = params;

  return {
    myUserEntryById: populate(state.firestore, `${seasonId}#${myUserEntry}`, firestoreConstants.populateUserIds),
    myUserEntryAll: state.firestore.ordered[`${seasonId}#${myUserEntry}`],
    seasons: state.firestore.data.seasons,
  };
}

function registerFirestoreListeners(props) {
  const params = get(props, "match.params");
  const {
    seasonId,
  } = params;

  return [
    {
      collection: "seasons",
      doc: seasonId,
    },
    ...(props.user ? [
    {
      collection: "seasons",
      doc: seasonId,
      subcollections: [{
        collection: "user_entries",
        where: ["userId", "==", props.user.uid],
      }],
      populates: firestoreConstants.populateUserIds,
      storeAs: `${seasonId}#${myUserEntry}`,
    }] : [])
  ];
}

export default compose(
  withStyles(styles),
  withRouter,
  firestoreConnect(registerFirestoreListeners),
  connect(mapStateToProps),
)(HomePage);
